/**
 * DXEへのお知らせ
 */
 import Vue from 'vue'
 import * as httpConst from '../../../constants/httpConst'
 import * as types from '../../mutation-types/admin-types'

const API_PATH = `${httpConst.ADMIN_ENDPOINT}/dxe_notifications`

const dxe_notification = {
  namespaced: true,
    state: {
      pagination: {
        current_page: 1,
        total_count: 0
      },
      condition: {
        name: null
      },
    },
    getters: {
      hasResult: ( state ) => {
        return (state.pagination.total_count > 0)
      },
    },
    actions: {
       index ({ dispatch, commit, state }, { name, page }) {
        dispatch('saveCondition', { name: name })
        const params = { name: state.condition.name, page: page }
        return new Promise((resolve) => {
          Vue.$http.get(API_PATH, { params: params }).then(data => {
            let content = data.content
            commit(types.ADMIN_DXE_NOTIFICATION, { content })
            resolve(data.content)
          })
        })
      },
      show ({ commit }, { id }) {
        const api_path = `${API_PATH}/${id}`
        return new Promise((resolve) => {
          Vue.$http.get(api_path).then(data => {
            commit
            resolve(data.content)
          })
        })
      },
      new () {
        const api_path = `${API_PATH}/new`
        return new Promise((resolve) => {
          Vue.$http.get(api_path).then(data => {
            resolve(data.content)
          })
        })
      },
      create ({ commit }, { params }) {
        return new Promise( ( resolve ) => {
          Vue.$http.post(API_PATH, params).then( data => {
            let content = data.content
            commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
            resolve(content)
          } )
        })
  
      },
      edit ({ commit }, { id }) {
        const api_path = `${API_PATH}/${id}/edit`
        return new Promise((resolve) => {
          Vue.$http.get(api_path).then(data => {
            commit
            resolve(data.content)
          })
        })
      },
      update ({ commit },{ id, params }) {
        const api_path = `${API_PATH}/${id}`
        return new Promise( ( resolve ) => {
          Vue.$http.put(api_path, params).then( data => {
            let content = data.content
            commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
            resolve(content)
          } )
        })
      },
      destroy ({ commit }, { id }) {
        const api_path = `${API_PATH}/${id}`
        return new Promise( ( resolve ) => {
          Vue.$http.delete(api_path).then(data => {
            commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
            resolve(data.content)
          })
        })
      },
      saveCondition ({ commit, state }, { name }) {
        const _name = (name !== undefined) ? name : state.condition.name
        const params = { name: _name }
        commit(types.ADMIN_DXE_NOTIFICATION_CONDITION, { params })
      },
    },   
    mutations: {
      [types.ADMIN_DXE_NOTIFICATION] (state, { content }) {
        state.pagination = content.pagination
      },
      [types.ADMIN_DXE_NOTIFICATION_CONDITION] (state, { params }) {
        state.condition.name = params.name
      }
    }, 
}

export default dxe_notification
